import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import { toCartModel } from '../../utils/ecommerce/cart.js';
import { getRootDomain } from '../../utils/common/url';

class CartHelper {
	constructor(props) {
		this.currDomain = this.getCookieDomain();
	}

	getCookieDomain() {
		let cookieDom = '';
		try {
			cookieDom = getRootDomain(location.host);
		} catch (e) {
			console.error(`[Cookie domain issue: ${e}`);
		}

		return cookieDom; // Cookie if issue do not set let browser to set default
	}

	getAuthToken() {
		const esriAuthCookie = this.getAuthCookie();
		let token = null;
		if (esriAuthCookie) {
			let parsedEsriAuthCookie = JSON.parse(decodeURIComponent(esriAuthCookie));
			token = parsedEsriAuthCookie.token;
		}
		return token;
	}

	getAuthCookie() {
		return Cookies.get('esri_auth');
	}

	isUserLoggedIn() {
		return Cookies.get('esri_auth') ? true : false;
	}

	setCookieCart(cartId) {
		let cartObj = {
			expires: 2000,
			path: '/',
		};
		if (this.currDomain !== '') {
			cartObj.domain = this.currDomain; // if issue setting cookie domain let browser default to current domain.
		}
		Cookies.set('eCommCartId', cartId, cartObj);
	}

	getCartId() {
		return Cookies.get('eCommCartId');
	}

	removeExistingCartCookie(error) {
		let cartCookieId = this.getCartId();
		if (cartCookieId) {
			Cookies.remove('eCommCartId', { domain: this.currDomain });
			console.error('Removing cookie cart - no response from api: ', error);
		}
	}

	getNewCartReqModel(initCardData, prodConfig, cart, bundleTitile) {
		const initialCartData = cart?._id ? cart : initCardData;
		let model = toCartModel(initialCartData);
		let startDate = dayjs();
		let endDate = dayjs(startDate).add(1, 'years').subtract(1, 'days');
		let newLineItems = {};
		prodConfig.data.forEach((item) => {
			let numSku = parseInt(item.SKU);
			newLineItems[numSku] = {
				termLicense: true,
				quantity: item.qty,
				materialNumber: numSku,
				price: item.price,
				productName: `${bundleTitile} ${item.licenceTypeTitle}`,
				startDate: dayjs(startDate).format('YYYY-MM-DD') + 'T00:00:00Z',
				endDate: dayjs(endDate).format('YYYY-MM-DD') + 'T00:00:00Z',
				metadata: {
					productInfo: {
						productPath: item.cfPath,
						productIcon: item.productIcon,
						shortDescription: item.shortDescription,
						pricingPageUrl: window.location.pathname,
					},
				},
			};
			return newLineItems;
		});
		// check if cart exist and it has lineitems
		let noMatchItems = [];
		if (cart.lineItems && cart.lineItems.length) {
			// check if prod exist on current cart
			let lineItems = cart.lineItems.map((prod) => {
				let currSku = parseInt(prod.materialNumber);
				let currProd = newLineItems[currSku];
				if (currProd && 'quantity' in currProd) {
					// if prod exist in cart update
					prod.quantity = prod.quantity + currProd.quantity;
					prod.productName = currProd.productName;
					currProd.isActive = true;
					return prod;
				} else {
					// if prod doesn't match return
					return prod;
				}
			});
			// if there was no match append new prod to cart.
			for (let lineItem in newLineItems) {
				if (!newLineItems[lineItem].isActive) {
					lineItems.push(newLineItems[lineItem]);
				}
			}

			// add prod to call
			model.lineItems = lineItems;
		} else {
			// if new cart, no lineitems exist

			for (let lineItem in newLineItems) {
				noMatchItems.push(newLineItems[lineItem]);
			}
			model.lineItems = noMatchItems;
		}

		return JSON.stringify(model);
	}
}

export default CartHelper;
